<div class="hotel-map-mobile">
  <div map style="width: 100%; height: 100%">
    <app-hotels-map
      [hotels]="currentHotels"
      [needBottomPadding]="true"
      (selectedHotelIndex)="scrollToHotel($event)"
    ></app-hotels-map>
  </div>

  <div class="hotel-map-mobile__swiper">
    <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
      <div class="swiper-wrapper">
        @for (hotel of hotels; track hotel.id; let idx = $index) {
          <div class="swiper-slide">
            <app-hotel-card-mobile
              [hotel]="hotel"
              [countryName]="countryName"
              [cityName]="cityName"
              [cityId]="cityId"
              [isSmallCard]="true"
            ></app-hotel-card-mobile>
          </div>
        }
      </div>
    </div>
  </div>
</div>
